__turbopack_context__.v({
  "root": "RankPill-module__lBjAEG__root",
});
